var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dashboard"},[_c('img',{attrs:{"alt":"Vue logo","src":require("@/assets/bg.jpg"),"width":"500px"}}),_c('footer-controlla')],1)}
var staticRenderFns = []

export { render, staticRenderFns }